import {
  Box,
  Center,
  Grid,
  GridItem,
  Input,
  InputGroup,
  InputLeftElement,
  Spinner,
  Text,
} from '@chakra-ui/react'
import { SearchIcon } from '@chakra-ui/icons'
import React, { useEffect, useMemo, useState } from 'react'
import DeviceListItem from './DeviceListItem'
import { debounce } from '../../../../utils/helpers'
import { DeviceLite } from '../../api/types'

interface Props {
  devices: DeviceLite[]
  search: string
  isFetching: boolean
  setSearch: (value: string) => void
}

export default function DeviceList(props: Props) {
  const { devices, search, isFetching, setSearch } = props
  const [inputValue, setInputValue] = useState(search)

  const debouncedSetSearch = useMemo(() => debounce(setSearch, 300), [setSearch])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setInputValue(value)
    debouncedSetSearch(value)
  }

  useEffect(() => {
    setInputValue(search)
  }, [search])

  const filteredDevices = (devices ?? []).filter((device) =>
    device.title?.toLowerCase().includes(search.toLowerCase()),
  )

  return (
    <Box>
      <Grid
        templateColumns="3fr 2fr 2fr 1fr 1fr 250px"
        px={4}
        py={2}
        borderBottom="1px solid"
        borderColor="gray.200"
        alignItems="center"
      >
        <GridItem>
          <Text fontFamily="Inter" fontWeight={500} fontSize="12px" color="#484848">
            Device
          </Text>
        </GridItem>
        <GridItem>
          <Text fontFamily="Inter" fontWeight={500} fontSize="12px" color="#484848">
            Physical ID
          </Text>
        </GridItem>
        <GridItem>
          <Text fontFamily="Inter" fontWeight={500} fontSize="12px" color="#484848">
            Location
          </Text>
        </GridItem>
        <GridItem>
          <Text fontFamily="Inter" fontWeight={500} fontSize="12px" color="#484848">
            Department
          </Text>
        </GridItem>
        <GridItem>
          <Text fontFamily="Inter" fontWeight={500} fontSize="12px" color="#484848">
            Recent Activity
          </Text>
        </GridItem>
        <GridItem>
          <InputGroup size="sm">
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="gray.400" />
            </InputLeftElement>
            <Input
              placeholder="Search device name"
              rounded="full"
              value={inputValue}
              onChange={handleChange}
            />
          </InputGroup>
        </GridItem>
      </Grid>

      {isFetching ? (
        <Center py={6}>
          <Spinner size="lg" />
        </Center>
      ) : (
        <>
          {filteredDevices.map((device, index) => (
            <DeviceListItem
              key={device.id}
              device={device}
              isLast={index === filteredDevices.length - 1}
            />
          ))}
          {filteredDevices.length === 0 && (
            <Center py={6}>
              <Text color="gray.500" fontStyle="italic">No devices found.</Text>
            </Center>
          )}
        </>
      )}
    </Box>
  )
}
